import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

const CheckerDashboard = () => {
  const [stats, setStats] = useState({ material: 0, vendor: 0 });

  useEffect(() => {
    api.get('/material-requests/checking').then(r => setStats(s => ({ ...s, material: r.data.length }))).catch(() => {});
    api.get('/vendor-requests/checking').then(r => setStats(s => ({ ...s, vendor: r.data.length }))).catch(() => {});
  }, []);

  const cards = [
    { label: 'Material Requests Pending Review', count: stats.material, to: '/checker/review/material', color: '#D95A1A' },
    { label: 'Vendor Requests Pending Review',   count: stats.vendor,   to: '/checker/review/vendor',   color: '#1A2C80' },
  ];

  return (
    <div>
      <div style={S.banner}>
        <div style={S.bannerCircle} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={S.bannerTitle}>Checker Dashboard</div>
          <div style={S.bannerSub}>Review and forward requests submitted by users to approvers</div>
        </div>
      </div>
      <div style={S.grid}>
        {cards.map(c => (
          <Link key={c.to} to={c.to} style={{ ...S.card, borderTop: `4px solid ${c.color}`, textDecoration: 'none' }}>
            <div style={S.count}>{c.count}</div>
            <div style={S.cardLabel}>{c.label}</div>
            <div style={{ ...S.badge, background: c.color }}>View →</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const S = {
  banner: { background: 'linear-gradient(135deg,#0891b2,#0e7490)', borderRadius: 14, padding: '24px 28px', marginBottom: 24, position: 'relative', overflow: 'hidden' },
  bannerCircle: { position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', top: -60, right: -40 },
  bannerTitle: { color: '#fff', fontSize: 20, fontWeight: 800, marginBottom: 4 },
  bannerSub: { color: 'rgba(255,255,255,0.75)', fontSize: 13 },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 },
  card: { background: '#fff', borderRadius: 14, padding: '24px 28px', boxShadow: '0 2px 12px rgba(11,21,84,0.07)', display: 'flex', flexDirection: 'column', gap: 8 },
  count: { fontSize: 40, fontWeight: 900, color: '#0B1554' },
  cardLabel: { fontSize: 14, color: '#4a5568', fontWeight: 600 },
  badge: { alignSelf: 'flex-start', color: '#fff', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 20, marginTop: 4 },
};

export default CheckerDashboard;
